import { useContext } from "react"
import { StaticContextType, StaticContext } from "../staticContext"

export const useStaticContext = (): StaticContextType => {
  const authctx = useContext(StaticContext) as StaticContextType
  if (!authctx) {
    console.error("no provider found, major error")
  }
  return authctx
}
